import React from 'react'
import { Permission } from 'settings/schema'
import { PermissionGroup, PermissionGroupContent } from '../components/permissionGroup'
import { PermissionToggle } from '../components/permissionToggle'
import { useTranslation } from 'translations'

interface ConviousAiPermissionGroupProps {
    isPulseAccessGranted: boolean
    handlePermissionClick: (permission: Permission, granted: boolean) => void
}

// Unlike the other groups, these toggles stay editable for admins: the AI
// claims are stored verbatim in the user's token instead of being implied
// by partner_admin.
export const ConviousAiPermissionGroup = ({
    isPulseAccessGranted,
    handlePermissionClick,
}: ConviousAiPermissionGroupProps) => {
    const { t } = useTranslation()

    return (
        <PermissionGroup
            brandedTitle={t('settings.users.form.groups.ai')}
            expanded={isPulseAccessGranted}
            className="convious-ai-permissions"
        >
            <div className="row">
                <PermissionToggle permission="access_pulse" handleClick={handlePermissionClick} />
            </div>
            <PermissionGroupContent height={24}>
                <div className="row">
                    <PermissionToggle permission="access_pulse_sales" handleClick={handlePermissionClick} />
                    <PermissionToggle permission="mcp" handleClick={handlePermissionClick} />
                    <PermissionToggle permission="access_ai_assistant" handleClick={handlePermissionClick} />
                </div>
            </PermissionGroupContent>
        </PermissionGroup>
    )
}
